// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Arrow_arrow__Mo_fm","quizInactive":"Arrow_quizInactive__Q3x_v"};